import {message as globalMessage} from "antd";

/* The one copy of a text that used to be inlined in every tab.
   Two spellings were in the codebase — 'Каторни танланг' (60 places) and
   'Қаторни танланг' (2). The majority one is kept so nothing changes on
   screen; note that the correct Uzbek spelling is the second one, and it is
   what i18n.js:41 already uses, so fixing it is now a one-line change here
   instead of an edit in 19 files. */
export const SELECT_ROW_WARNING = 'Каторни танланг';

/**
 * Guard for the table actions that need a selected row.
 *
 *     if (!requireSelectedRow(selectedRowKeys, messageApi)) return false;
 *
 * `selection` is either the selectedRowKeys array or the selected row itself —
 * both shapes are used by the tabs — and an empty array counts as no selection.
 *
 * `notify` takes the messageApi returned by message.useMessage(), so the
 * warning is rendered by the component's own context holder. It is optional:
 * without it the global antd message is used, which is what the tabs that have
 * no context holder were already doing.
 */
export const requireSelectedRow = (selection, notify) => {
    const hasSelection = Array.isArray(selection) ? selection.length > 0 : Boolean(selection);
    if (hasSelection) return true;

    (notify || globalMessage).warning(SELECT_ROW_WARNING);
    return false;
};
